import React from 'react';
import customComponentList from './customComponentList';
import { Toast } from 'antd-mobile';
import './CustomComponent.less';

/**
 * 提示当前组件正在开发中
 */
const DevelopCustomComponent = () => (
  <div className="custom-component develop">该组件仅支持小程序端查看</div>
);
/**
 * 不显示组件数据
 */
const hiddenCustomComponentList = {
  // 旧版个人中心组件
  'user-center': true,
  // 旧版底部导航组件
  'bottom-nav': true,
}

/**
 * @desc {showToast} 点击图片给的提示语 
 */
const showToast = ()=> {
  Toast.info('仅为预览图效果，实际功能请在小程序端体验')
}
/**
 * 定义对应组件的 图片路径 替换 DevelopCustomComponent 组件
 */
const UnDoFuncComponent = (props) => (
  <div className="custom-component" onClick={showToast}>
    <img className="unDoFuncImg" src={props.url} alt=""/>
  </div>
);
const showPicObj = {
  'live': (props)=> {                                        // 直播
    let mode = props.data.customFeature.mode || 1;
    return `http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/live-mode${mode}.png`;
  },
  'video-list-tiktok': (props) => {                          // 抖音视频 
    return `http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/tiktok.png`;
  },
  'times-card': (props)=> {                                  // 服务卡
    let { card_type, TCType }  = props.data.customFeature;
    let type = '1';
    if (card_type === 0 && TCType === 2) {          // 次卡 样式1
      type = '1';
    }else if (card_type === 0 && TCType === 1) {    // 次卡 样式2
      type = '2';
    }else if (card_type === 2 && TCType === 2) {    // 充值卡 样式1
      type = '3';
    }else if (card_type === 2 && TCType === 1) {    // 充值卡 样式2
      type = '4';
    }
    return `http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/time-card-mode${type}.png`;
  },
  'shopping-card-list': (props)=> {                          // 购物卡
    let mode = props.data.customFeature.mode || 0;
    return `http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/shopping-card-mode${mode}.png`;
  },
  'gift-card-list': (props)=> {                              // 礼品卡 同上
    let mode = props.data.customFeature.mode || 0;
    return `http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/shopping-card-mode${mode}.png`;
  },
  'dynamic-navigation': (props)=> {                          // 分类导航
    let mode = props.data.customFeature.mode || 0;
    return `http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/dynamic-navigation-mode${mode}.png`;
  },
  'customer-service': (props)=> {                            // 智能回复
    return `http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/customer-service.png`
  },
}

function CustomComponent(props) {
  if (props.data.hidden) {
    return null;
  }
  // 组件类型
  const type = props.data.type;
  // 当前组件不存在类型字段
  if (!type) {
    return null;
  }
  if (customComponentList[type]) {
    // 已开发组件
    const { forwardedRef, ...rest } = props;
    return customComponentList[type](rest, forwardedRef);
  } else if (hiddenCustomComponentList[type]) {
    // 不显示组件
    return null;
  } else{
    // 用图片替换之前的文案 不需要处理的要过滤掉
    return <UnDoFuncComponent url={ showPicObj[type] && showPicObj[type](props) } />;
  }
}

export default React.forwardRef((props, ref) => {
  return <CustomComponent {...props} forwardedRef={ref}/>
})


// WEBPACK FOOTER //
// ./src/custom-component/CustomComponent.jsx